import { createContext, useCallback, useContext, useState } from "react";
import { api } from "@/lib/api";
import { DispositionDrawer } from "@/components/DispositionDrawer";

const CrmCtx = createContext(null);

export const CrmProvider = ({ children }) => {
  const [target, setTarget] = useState(null);
  const [tick, setTick] = useState(0);
  const refresh = useCallback(() => setTick((t) => t + 1), []);

  const openDisposition = useCallback((lead, meeting = null, channel = "CALL") => setTarget({ lead, meeting, channel }), []);

  const logAndOpen = useCallback(async (lead, channel) => {
    try { await api.post(`/leads/${lead.id}/communications`, { channel }); } catch (e) { /* non-blocking */ }
    const meeting = lead.pending_meeting || lead.live_meeting || null;
    setTimeout(() => setTarget({ lead, meeting, channel }), 700);
  }, []);

  return (
    <CrmCtx.Provider value={{ tick, refresh, openDisposition, logAndOpen }}>
      {children}
      <DispositionDrawer target={target} onClose={() => setTarget(null)} onDone={() => { setTarget(null); refresh(); }} />
    </CrmCtx.Provider>
  );
};

export const useCrm = () => useContext(CrmCtx);
